import * as React from 'react';

import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { colors } from "app/common/arctechv2/theme";

/* @jsxImportSource @emotion/react */  import { css, jsx } from '@emotion/react'; /* eslint-disable-line */

const componentCss = css`

	width: 300px;

	.site-menu-section-body {
		padding: var(--siteMenuSpacing);
	}

	.nav-link {
		background-color: #f5f8fa;
		border-radius: .475rem;
		margin-bottom: .5rem;
		align-items: center;
		display: flex;
		padding: 1rem;
		transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
		text-decoration: none;
		color: ${colors.darkNavy};
		transition: color .2s ease,background-color .2s ease;
		color: ${colors.darkNavy};
		font-weight: 600;
		font-size: 1.075rem;
		width: 230px;

		&:hover {
			color: #7e8299;
			border-color: #e4e6ef;
			background-color: #e4e6ef;
		}

		&:hover {
			color: #7e8299;
			border-color: #e4e6ef;
			background-color: #e4e6ef;
		}
	}

`;

export default React.forwardRef(({ selectedNav }, ref) => {

	return <div css={componentCss} ref={ref} className={"SiteMenu__section " + (selectedNav == 0 ? "" : selectedNav < 8 ? "SiteMenu__section--right" : "")} hidden={selectedNav !== 8}>
		<section className="site-menu-section">
			<div className="site-menu-section-body">
				<Link className="nav-link" to="/u/users/self">My Account</Link>
				<Link className="nav-link" to="/auth/logout">Logout</Link>
			</div>
		</section>
	</div>

});
